//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';
import { LangSelector } from '@/components/LangSelector';

//components
import {
  Layout,
  Title,
  TitleH2,
  TitleH3,
  TitleH4,
  Paragraph,
  Link,
  BulltetList,
  Header,
} from '@/components/Typography/Legal';

const SubscriptionAndProfessionalServicesAgreementPT = () => {
  return (
    <>
      <Navigation />
      <>
        <Layout>
          <Header>
            <Title>Acordo de Assinatura e Serviços Profissionais</Title>
            <div>
              <LangSelector language="pt" />
            </div>
          </Header>
          <Paragraph>
            <i>Última atualização: 12 de agosto de 2024</i>
          </Paragraph>
          <Paragraph>
            Este Acordo de Assinatura e Serviços Profissionais entra em vigor na
            Data de Vigência e é celebrado entre o Cliente e a Loadsmart,
            estabelecendo os termos e condições que regem o acesso e uso dos
            Serviços pelo Cliente.
          </Paragraph>
          <div>
            <TitleH2>1. DEFINIÇÕES</TitleH2>
            <Paragraph>
              <strong>1.1. “Afiliada”</strong> significa, em relação a uma
              parte, qualquer entidade que (i) seja controlada por, (ii)
              controle, ou (iii) esteja sob controle comum com tal parte, onde o
              termo “controle” significa a titularidade, direta ou
              indiretamente, de mais de cinquenta por cento (50%) das ações com
              direito a voto para eleição de diretores.
            </Paragraph>
            <Paragraph>
              <strong>1.2. “Acordo”</strong> significa este Acordo de Assinatura
              e Serviços Profissionais juntamente com o Formulário de Pedido ou
              Declaração de Trabalho aplicável executado pelo Cliente.
            </Paragraph>
            <Paragraph>
              <strong>1.3. “Usuário Autorizado”</strong> significa um
              funcionário do Cliente que foi autorizado pelo Cliente a acessar e
              utilizar os Serviços de Assinatura.
            </Paragraph>
            <Paragraph>
              <strong>1.4. “Informações Confidenciais”</strong> significa todas
              as informações não públicas de uma parte, incluindo, mas não se
              limitando a, todos os dados técnicos, segredos comerciais,
              know-how, pesquisas, ideias ou planos de produtos ou serviços,
              códigos e designs de software, algoritmos, desenvolvimentos,
              invenções, pedidos de patentes, cadernos de laboratório,
              processos, fórmulas, técnicas, obras de máscara, projetos e
              desenhos de engenharia, informações de configuração de hardware,
              acordos com terceiros, listas ou informações relativas a
              funcionários e consultores da Parte Divulgadora (incluindo, mas
              não se limitando a, nomes, informações de contato, cargos,
              remuneração e expertise de tais funcionários e consultores),
              listas ou informações relativas a clientes, listas de preços,
              metodologias de precificação, dados de custos, dados de
              participação de mercado, planos de marketing, licenças,
              informações contratuais, planos de negócios, previsões
              financeiras, dados financeiros históricos, orçamentos ou outras
              informações comerciais, e nomes de usuário e senhas para os
              Serviços de Assinatura divulgadas pela Parte Divulgadora (seja em
              formato oral, escrito, gráfico ou legível por máquina) à Parte
              Receptora, as quais são designadas como confidenciais ou
              proprietárias, ou que, nas circunstâncias, pareceriam a uma pessoa
              razoável ser confidenciais ou proprietárias.
            </Paragraph>
            <Paragraph>
              <strong>1.5. “Cliente”</strong> significa a entidade jurídica que
              não a Loadsmart identificada no Formulário de Pedido ou Declaração
              de Trabalho aplicável.
            </Paragraph>
            <Paragraph>
              <strong>1.6. “Dados do Cliente”</strong> significa quaisquer dados
              fornecidos pelo Cliente ou seus Usuários Autorizados à Loadsmart
              durante a prestação dos Serviços, incluindo Dados Pessoais e
              Informações Pessoais sobre Usuários Autorizados, excluindo
              especificamente quaisquer Dados de Usuários Terceiros e Dados de
              Uso. Os Dados do Cliente constituem Informações Confidenciais do
              Cliente.
            </Paragraph>
            <Paragraph>
              <strong>1.7. “Entregáveis”</strong> significa o produto de
              trabalho concluído especificamente identificado como entregável na
              Declaração de Trabalho ou Formulário de Pedido aplicável.
            </Paragraph>
            <Paragraph>
              <strong>1.8. “Documentação”</strong> significa a documentação
              técnica relativa aos Serviços de Assinatura fornecida pela
              Loadsmart ao Cliente.
            </Paragraph>
            <Paragraph>
              <strong>1.9. “Data de Vigência”</strong> significa (a) no caso dos
              Serviços de Assinatura, a data mais antiga entre: (i) o acesso
              inicial do Cliente aos Serviços de Assinatura aplicáveis em
              qualquer capacidade, ou (ii) a assinatura pelo Cliente do
              Formulário de Pedido aplicável; ou (b) no caso dos Serviços
              Profissionais, a data de vigência indicada na Declaração de
              Trabalho aplicável.
            </Paragraph>
            <Paragraph>
              <strong>1.10. “Reivindicação Excluída”</strong> significa
              responsabilidades decorrentes de: (i) negligência grave, conduta
              dolosa ou fraude de uma parte; (ii) violação de lei aplicável por
              uma parte; (iii) violação pelo Cliente da Seção 2.2; (iv)
              obrigações de indenização do Cliente previstas na Seção 10.1; ou
              (v) violação das obrigações de confidencialidade previstas na
              Seção 7.1 por uma parte.
            </Paragraph>
            <Paragraph>
              <strong>1.11. “Feedback”</strong> significa quaisquer sugestões,
              ideias, conceitos, know-how, técnicas, comentários ou perguntas
              contendo feedback sobre os Serviços enviados pelo Cliente ou seus
              Usuários Autorizados.
            </Paragraph>
            <Paragraph>
              <strong>1.12. “Honorários”</strong> significa quaisquer honorários
              pagos pelo Cliente pelos Serviços, conforme estabelecido no
              Formulário de Pedido ou Declaração de Trabalho aplicável.
            </Paragraph>
            <Paragraph>
              <strong>1.13. “Propriedade Intelectual”</strong> significa todas e
              quaisquer invenções, segredos comerciais, know-how,
              desenvolvimentos, melhorias, resultados, dados, designs,
              interfaces visuais, gráficos, compilações, informações, código de
              computador (incluindo código-fonte ou código-objeto), produtos,
              software, serviços e quaisquer outros direitos de propriedade
              intelectual reconhecidos em qualquer país ou jurisdição do mundo.
            </Paragraph>
            <Paragraph>
              <strong>1.14. “Loadsmart”</strong> significa Loadsmart, Inc. e
              suas subsidiárias integrais e Afiliadas.
            </Paragraph>
            <Paragraph>
              <strong>1.15. “Formulário de Pedido”</strong> significa um pedido
              de Serviços de Assinatura em formato aprovado pela Loadsmart, que
              incorpora este Acordo e seus termos por referência.
            </Paragraph>
            <Paragraph>
              <strong>1.16. “Serviços Profissionais”</strong> significa os
              serviços a serem prestados pela Loadsmart conforme descrito na
              Declaração de Trabalho ou Formulário de Pedido aplicável.
            </Paragraph>
            <Paragraph>
              <strong>1.17. “Incidente de Segurança”</strong> significa a
              aquisição não autorizada real de Dados do Cliente, Informações
              Pessoais ou Informações Confidenciais de uma parte que são
              mantidas ou armazenadas pela outra parte, ou o acesso ou uso não
              autorizado real ou suspeito dos Serviços de Assinatura.
            </Paragraph>
            <Paragraph>
              <strong>1.18. “Serviços”</strong> significa tanto os Serviços de
              Assinatura quanto os Serviços Profissionais, coletivamente.
            </Paragraph>
            <Paragraph>
              <strong>1.19. “Software”</strong> significa a plataforma de
              Software-como-Serviço de propriedade e operada pela Loadsmart por
              meio da qual um Usuário Autorizado pode acessar os Serviços de
              Assinatura.
            </Paragraph>
            <Paragraph>
              <strong>1.20. “Declaração de Trabalho”</strong> significa um
              documento executado por ambas as partes descrevendo os Serviços
              Profissionais a serem prestados pela Loadsmart e os Entregáveis
              associados.
            </Paragraph>
            <Paragraph>
              <strong>1.21. “Serviços de Assinatura”</strong> significa a
              assinatura de Software online e hospedada fornecida pela
              Loadsmart. O escopo dos Serviços de Assinatura adquiridos pelo
              Cliente poderá ser descrito com maior detalhe no Formulário de
              Pedido.
            </Paragraph>
            <Paragraph>
              <strong>1.22. “Período de Assinatura”</strong> significa o período
              compreendido entre a data de início do serviço e a data de término
              do serviço, conforme estabelecido no Formulário de Pedido
              aplicável.
            </Paragraph>
            <Paragraph>
              <strong>1.23. “Usuário Terceiro”</strong> significa um usuário que
              acessa os Serviços de Assinatura e não é o Cliente nem a
              Loadsmart.
            </Paragraph>
            <Paragraph>
              <strong>1.24. “Dados de Uso”</strong> significa qualquer
              informação derivada do Software em decorrência do uso dos Serviços
              de Assinatura pelo Cliente, incluindo, mas não se limitando a,
              dados, estatísticas, tendências, padrões e informações similares.
            </Paragraph>
          </div>
          <div>
            <TitleH2>2. SERVIÇOS DE ASSINATURA</TitleH2>
            <Paragraph>
              <TitleH3>2.1. Serviços de Assinatura.</TitleH3>A Loadsmart
              fornecerá os Serviços de Assinatura de acordo com este Acordo
              durante o Período de Assinatura. O Cliente poderá acessar e
              utilizar os Serviços de Assinatura exclusivamente para seus fins
              comerciais internos, sujeito aos termos deste Acordo, sendo tal
              acesso e uso expressamente limitado aos Usuários Autorizados do
              Cliente.
            </Paragraph>
            <Paragraph>
              <TitleH3>2.2. Restrições.</TitleH3>O Cliente não deverá tentar
              interferir ou interromper os Serviços de Assinatura ou o Software,
              nem tentar obter acesso a quaisquer sistemas ou redes conectados a
              eles (exceto conforme necessário para acessar e utilizar os
              Serviços de Assinatura). O Cliente não deverá permitir o acesso ou
              uso dos Serviços de Assinatura por pessoas que não sejam Usuários
              Autorizados. O Cliente não deverá, e deverá garantir que seus
              Usuários Autorizados não: (a) copiem, modifiquem ou distribuam
              qualquer parte dos Serviços de Assinatura ou do Software; (b)
              aluguem, arrendem ou forneçam acesso aos Serviços de Assinatura ou
              ao Software em regime de compartilhamento de tempo ou prestação de
              serviços a terceiros; (c) utilizem os Serviços de Assinatura ou o
              Software para fornecer, ou incorporem os Serviços de Assinatura ou
              o Software em, qualquer produto ou serviço fornecido a terceiros;
              (d) façam engenharia reversa, decompilem, desmontagem ou de outra
              forma tentem obter o código-fonte ou APIs não públicas
              relacionadas aos Serviços de Assinatura ou ao Software; ou (e)
              transfiram quaisquer de seus direitos aqui previstos (exceto
              conforme expressamente estabelecido neste instrumento).
            </Paragraph>
            <Paragraph>
              <TitleH3>2.3. Uso Aceitável.</TitleH3>O Cliente deverá utilizar os
              Serviços de Assinatura exclusivamente para fins autorizados e
              legais, em conformidade com as leis e regulamentos aplicáveis e os
              direitos de terceiros, e de acordo com o Formulário de Pedido
              aplicável. Com exceção dos Dados do Cliente, o Cliente somente
              poderá utilizar dados, informações ou outros conteúdos derivados
              dos Serviços de Assinatura para fins comerciais internos do
              Cliente, na medida necessária para fazer uso dos Serviços de
              Assinatura. O Cliente será integralmente responsável por todos os
              atos ou omissões de seus Usuários Autorizados em conexão com os
              Serviços de Assinatura, como se tivessem sido praticados pelo
              próprio Cliente.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                2.4. Uso Ilegal e Não Autorizado dos Serviços de Assinatura.
              </TitleH3>
              A Loadsmart poderá imediatamente suspender ou encerrar o acesso do
              Cliente aos Serviços de Assinatura, mediante notificação por
              escrito ao Cliente, caso (i) a Loadsmart determine, com base em
              evidências razoáveis, que os Serviços de Assinatura estão sendo
              utilizados para atividades fraudulentas ou criminosas, ou em
              violação de qualquer lei ou regulamento aplicável ou deste Acordo;
              ou (ii) uma autoridade governamental, jurídica ou de aplicação da
              lei assim exija ou instrua a Loadsmart a encerrar ou suspender os
              Serviços de Assinatura para o Cliente. O Cliente é e será o único
              responsável por qualquer uso fraudulento, mau uso ou atividade
              ilegal conduzida nos Serviços de Assinatura por seus Usuários
              Autorizados.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                2.5. Procedimentos de Manutenção e Backup de Dados.
              </TitleH3>
              Os Serviços de Assinatura não se destinam a ser uma solução de
              armazenamento ou backup de dados. No caso de perda ou corrupção de
              Dados do Cliente, a Loadsmart envidará esforços comercialmente
              razoáveis para restaurar os Dados do Cliente perdidos ou
              corrompidos a partir do backup mais recente de tais dados mantido
              pela Loadsmart. O Cliente reconhece que a restauração completa dos
              Dados do Cliente pode não ser possível em todas as circunstâncias
              e que a Loadsmart não terá qualquer responsabilidade perante o
              Cliente nesse caso.
            </Paragraph>
          </div>
          <div>
            <TitleH2>3. SERVIÇOS PROFISSIONAIS</TitleH2>
            <Paragraph>
              <TitleH3>3.1. Declaração de Trabalho.</TitleH3>
              Periodicamente, o Cliente poderá solicitar que a Loadsmart execute
              determinados Serviços Profissionais. Cada contratação de Serviços
              Profissionais será descrita em detalhes em uma Declaração de
              Trabalho separada, executada por ambas as partes, incluindo, entre
              outros, honorários e despesas, cronogramas do projeto, requisitos
              de pessoal e recursos, e Entregáveis específicos.
            </Paragraph>
          </div>
          <div>
            <TitleH2>4. OBRIGAÇÕES DO CLIENTE</TitleH2>
            <Paragraph>
              <TitleH3>4.1. Cooperação e Assistência.</TitleH3>O Cliente deverá,
              a todo momento: (a) fornecer à Loadsmart cooperação e assistência
              de boa-fé, bem como acesso às informações e ao pessoal que possam
              ser razoavelmente necessários à Loadsmart para a prestação dos
              Serviços; e (b) cumprir tempestivamente todas as demais
              responsabilidades do Cliente estabelecidas neste Acordo.
            </Paragraph>
            <Paragraph>
              <TitleH3>4.2. Apoio de Marketing.</TitleH3>O Cliente concede à
              Loadsmart um direito limitado, não exclusivo, intransferível,
              revogável, de utilizar o nome, marcas e logotipos do Cliente
              (coletivamente, “Marcas do Cliente”) exclusivamente com o objetivo
              de identificar o Cliente como destinatário dos Serviços e em
              conformidade com quaisquer diretrizes de uso de marcas e logotipos
              fornecidas pelo Cliente à Loadsmart.
            </Paragraph>
          </div>
          <div>
            <TitleH2>5. HONORÁRIOS; TRIBUTOS</TitleH2>
            <Paragraph>
              <TitleH3>5.1. Honorários; Atraso no Pagamento.</TitleH3>O Cliente
              deverá pagar os honorários e despesas conforme estabelecido no
              Formulário de Pedido e na Declaração de Trabalho, conforme
              aplicável. Caso o uso dos Serviços de Assinatura pelo Cliente
              exceda os limites estabelecidos no Formulário de Pedido aplicável,
              o Cliente será responsável por quaisquer valores adicionais
              cobrados pela Loadsmart em decorrência disso. Após o Período de
              Assinatura inicial, a Loadsmart poderá reajustar os honorários dos
              Serviços de Assinatura no máximo uma vez a cada período de doze
              (12) meses. O Cliente é responsável por manter informações de
              faturamento e contato completas e precisas, e por notificar a
              Loadsmart sobre quaisquer alterações nessas informações. Todas as
              faturas vencem trinta (30) dias após o recebimento pelo Cliente.
              Caso uma fatura não seja paga tempestivamente, a Loadsmart terá o
              direito de cobrar juros sobre os valores em atraso à taxa de um e
              meio por cento (1,5%) ao mês, mas nunca superior à taxa máxima
              permitida por lei, calculada a partir da data de vencimento até a
              data de recebimento do pagamento pela Loadsmart. Além disso, se
              qualquer fatura ficar em atraso por mais de trinta (30) dias, a
              Loadsmart poderá: (i) para Serviços de Assinatura, suspender o
              acesso e uso dos Serviços de Assinatura pelo Cliente sem
              responsabilidade para com o Cliente; ou (ii) para Serviços
              Profissionais, cessar todos os trabalhos previstos na Declaração
              de Trabalho aplicável. Se a Loadsmart for obrigada a tomar medidas
              legais para cobrar honorários não contestados, o Cliente estará
              obrigado a reembolsar a Loadsmart pelos custos razoáveis de
              cobrança, incluindo honorários advocatícios razoáveis. Exceto
              conforme estabelecido nas Seções 9.2 e 10.2, todos os honorários
              pelos Serviços são não reembolsáveis.
            </Paragraph>
            <Paragraph>
              <TitleH3>5.2. Processamento de Pagamentos.</TitleH3>O Cliente
              autoriza a Loadsmart a cobrar automaticamente o cartão de crédito
              ou conta bancária do Cliente por todos os honorários devidos de
              acordo com o Formulário de Pedido ou Declaração de Trabalho
              aplicável. O Cliente ainda autoriza a Loadsmart a utilizar
              terceiros para processar pagamentos e consente com a divulgação
              das informações de pagamento do Cliente a tais terceiros. O
              Cliente notificará a Loadsmart imediatamente sobre qualquer
              alteração nas informações de faturamento do cartão de crédito ou
              conta bancária do Cliente.
            </Paragraph>
            <Paragraph>
              <TitleH3>5.3. Tributos.</TitleH3>
              Todos os valores e honorários mencionados neste Acordo, em
              qualquer Formulário de Pedido ou Declaração de Trabalho, são
              exclusivos de impostos, taxas, encargos, tarifas e outros tributos
              governamentais (incluindo, sem limitação, impostos sobre vendas,
              uso, GST, IVA, retenção na fonte ou tributos similares)
              (coletivamente, “Tributos”). Quando aplicável, a Loadsmart cobrará
              todos os Tributos do Cliente como item separado em cada fatura
              emitida em conexão com os Serviços.
            </Paragraph>
          </div>
          <div>
            <TitleH2>6. PROPRIEDADE INTELECTUAL</TitleH2>
            <Paragraph>
              <TitleH3>6.1. Propriedade Intelectual da Loadsmart.</TitleH3>A
              Loadsmart manterá todos os direitos, título e interesse sobre toda
              e qualquer Propriedade Intelectual: (i) nos Serviços de
              Assinatura, (ii) no Software, e (iii) desenvolvida pela Loadsmart
              antes do início dos Serviços Profissionais, independentemente dos
              Serviços Profissionais, e durante os Serviços Profissionais, desde
              que a Propriedade Intelectual aplicável não seja um Entregável,
              sendo que, em cada caso, todos os direitos de Propriedade
              Intelectual são e permanecerão de propriedade exclusiva e única da
              Loadsmart (coletivamente, “Propriedade Intelectual da Loadsmart”).
              A Loadsmart concede ao Cliente e a seus Usuários Autorizados uma
              licença limitada, não exclusiva, não sublicenciável,
              intransferível, rescindível e revogável sobre a Propriedade
              Intelectual da Loadsmart, na medida necessária para que o Cliente
              faça uso dos Serviços de Assinatura ou do Entregável aplicável
              para fins comerciais internos do Cliente, em conformidade com o
              Formulário de Pedido ou Declaração de Trabalho aplicável.
            </Paragraph>
            <Paragraph>
              <TitleH3>6.2. Propriedade Intelectual do Cliente.</TitleH3>O
              Cliente manterá todos os direitos, título e interesse sobre toda e
              qualquer Propriedade Intelectual: (i) nos Dados do Cliente, (ii)
              se aplicável e sujeito ao pagamento pelo Cliente de todos os
              honorários e despesas aplicáveis, nos Entregáveis, e (iii) nas
              Marcas do Cliente. Ao fornecer Dados do Cliente durante a
              prestação dos Serviços, o Cliente concede à Loadsmart o direito e
              a licença de usar, reproduzir, distribuir, modificar e adaptar os
              Dados do Cliente: (x) para fins de prestação dos Serviços ao
              Cliente, incluindo o direito de divulgar Dados do Cliente a
              funcionários, subsidiárias, Afiliadas, contratados, fornecedores e
              Usuários Terceiros da Loadsmart, na medida necessária para a
              prestação dos Serviços ao Cliente; e (y) para fins comerciais
              internos da Loadsmart (sujeito às obrigações de confidencialidade
              previstas na Seção 7.1).
            </Paragraph>
            <Paragraph>
              <TitleH3>
                6.3. Dados Agregados, de Uso e de Usuários Terceiros.
              </TitleH3>
              Não obstante qualquer disposição contrária neste Acordo, a
              Loadsmart poderá utilizar Dados do Cliente desidentificados ou
              agregados para qualquer finalidade comercial, incluindo, sem
              limitação, benchmarking setorial, orientações de melhores
              práticas, recomendações e relatórios similares que possam ser
              distribuídos externamente a outros clientes da Loadsmart. Além
              disso, nada contido neste Acordo ou no Formulário de Pedido ou
              Declaração de Trabalho aplicável restringirá ou proibirá a
              capacidade da Loadsmart de utilizar dados de Usuários Terceiros ou
              Dados de Uso para qualquer finalidade lícita.
            </Paragraph>
            <Paragraph>
              <TitleH3>6.4. Feedback.</TitleH3>A Loadsmart estará livre para
              usar, divulgar, reproduzir, licenciar ou de outra forma distribuir
              o Feedback conforme entender adequado, sem qualquer obrigação ou
              restrição de qualquer natureza em razão de direitos de Propriedade
              Intelectual ou de outra forma; desde que tal Feedback não contenha
              quaisquer elementos específicos ou identificáveis únicos ao
              Cliente ou suas operações. O Cliente não terá direitos de
              Propriedade Intelectual sobre os Serviços de Assinatura em
              decorrência da incorporação do Feedback pela Loadsmart aos
              Serviços de Assinatura.
            </Paragraph>
          </div>
          <div>
            <TitleH2>
              7. CONFIDENCIALIDADE; SEGURANÇA; PRIVACIDADE DE DADOS.
            </TitleH2>
            <Paragraph>
              <TitleH3>7.1. Obrigações de Confidencialidade.</TitleH3> Em
              conexão com este Acordo, uma parte (a “Parte Divulgadora”) poderá
              divulgar determinadas Informações Confidenciais à outra parte (a
              “Parte Receptora”). Durante a vigência deste Acordo e por um
              período de três (3) anos após seu vencimento ou rescisão, a Parte
              Receptora não divulgará as Informações Confidenciais da Parte
              Divulgadora para quaisquer fins que não o exercício de seus
              direitos e o cumprimento de suas obrigações nos termos deste
              Acordo. A Parte Receptora não deverá divulgar Informações
              Confidenciais a terceiros, exceto a funcionários, contratados,
              fornecedores e Afiliadas da Parte Receptora que tenham necessidade
              razoável de conhecer tais informações em conexão com este Acordo;
              desde que tais terceiros estejam juridicamente vinculados por
              obrigações de confidencialidade pelo menos tão rigorosas quanto as
              aqui previstas. A Parte Receptora deverá garantir que as
              Informações Confidenciais da Parte Divulgadora não sejam
              divulgadas ou distribuídas por seus funcionários, contratados,
              fornecedores ou Afiliadas em violação aos termos deste Acordo. A
              Parte Receptora tratará todas as Informações Confidenciais com o
              mesmo grau de cuidado que utiliza para proteger suas próprias
              Informações Confidenciais, mas em nenhum caso com grau de cuidado
              inferior ao razoável.
            </Paragraph>
            <Paragraph>
              As restrições de confidencialidade acima não se aplicarão a
              informações que a Parte Receptora possa demonstrar mediante
              evidência documental: (i) estarem ou se tornarem disponíveis no
              domínio público sem violação deste Acordo pela Parte Receptora;
              (ii) estavam em posse da Parte Receptora antes do recebimento da
              Parte Divulgadora; (iii) terem sido desenvolvidas de forma
              independente pela Parte Receptora sem uso ou referência às
              Informações Confidenciais; ou (iv) terem sido legitimamente
              recebidas pela Parte Receptora de terceiro que tenha direito de
              divulgação adicional.
            </Paragraph>
            <Paragraph>
              Não obstante o acima exposto, Informações Confidenciais poderão
              ser divulgadas conforme exigido por qualquer agência governamental
              ou processo judicial; desde que, antes de fornecer tais
              Informações Confidenciais, a Parte Receptora deva dar à Parte
              Divulgadora (na medida permitida pela lei aplicável) aviso prévio
              suficiente sobre a divulgação para permitir que a Parte
              Divulgadora exerça quaisquer direitos que possa ter para contestar
              ou limitar a divulgação de tais Informações Confidenciais.
            </Paragraph>
            <Paragraph>
              Mediante solicitação por escrito da Parte Divulgadora, a Parte
              Receptora deverá: (i) cessar o uso das Informações Confidenciais;
              (ii) devolver as Informações Confidenciais e todas as cópias,
              anotações ou extratos das mesmas à Parte Divulgadora no prazo de
              sete (7) dias úteis do recebimento da solicitação; e (iii)
              confirmar por escrito que a Parte Receptora cumpriu as obrigações
              estabelecidas neste parágrafo. Não obstante o acima exposto, a
              Parte Receptora poderá reter uma (1) cópia das Informações
              Confidenciais para monitorar o cumprimento contínuo deste Acordo e
              um número limitado de cópias de backup feitas de acordo com as
              políticas padrão de retenção de registros da Parte Receptora.
            </Paragraph>

            <Paragraph>
              <TitleH3>7.2. Obrigações de Segurança.</TitleH3>
              Cada parte deverá (i) manter práticas de segurança da informação
              comercialmente razoáveis para seus sistemas utilizados para
              fornecer ou acessar os Serviços de Assinatura, incluindo
              procedimentos e práticas de segurança adequados à natureza das
              informações inseridas ou armazenadas nos Serviços de Assinatura,
              projetados para prevenir o acesso, uso ou divulgação não
              autorizados de quaisquer Dados do Cliente e Informações
              Confidenciais ou um Incidente de Segurança; e (ii) cumprir todas
              as leis e regulamentos de privacidade e segurança de dados
              aplicáveis aos Serviços de Assinatura. Cada parte deverá notificar
              prontamente a outra parte sobre qualquer Incidente de Segurança.
              Quando o Cliente for a parte notificante, a notificação deverá ser
              dirigida a{' '}
              <Link href="mailto:security@loadsmart.com">
                Security@Loadsmart.com
              </Link>
              , com cópia para{' '}
              <Link href="mailto:legal@loadsmart.com">Legal@Loadsmart.com</Link>
              . A parte notificante investigará razoavelmente qualquer Incidente
              de Segurança. Para Incidentes de Segurança decorrentes de
              negligência grave ou conduta dolosa de uma parte, essa parte será
              responsável por (i) custos de multas governamentais ou
              regulatórias; e (ii) se exigido pela lei aplicável, fornecer
              notificação e/ou monitoramento de crédito ou proteção de
              identidade a qualquer titular de dados afetado pelo Incidente de
              Segurança aplicável e/ou fornecer notificação a qualquer entidade
              governamental, e pelos custos associados a tais notificações ou
              proteção de identidade (coletivamente, “Custos de Violação”). A
              Loadsmart não terá responsabilidade pelo pagamento de quaisquer
              Custos de Violação relacionados a um Incidente de Segurança
              causado por negligência, conduta dolosa, fraude ou violação da lei
              aplicável pelo Cliente ou seus Usuários Autorizados.
            </Paragraph>
            <Paragraph>
              <TitleH3>7.3. Privacidade de Dados.</TitleH3>O uso e acesso do
              Cliente aos Serviços, bem como o tratamento de Dados do Cliente
              pela Loadsmart, estarão sujeitos e serão regidos pela política de
              privacidade da Loadsmart, disponível em:
              <Link href="https://loadsmart.com/privacy-policy">
                https://loadsmart.com/privacy-policy
              </Link>
              , incorporada a este instrumento por referência. Quando o Cliente
              desejar que a Loadsmart realize o processamento de “Dados
              Pessoais” (conforme definido no Regulamento Geral de Proteção de
              Dados da União Europeia — “GDPR”) ou “Informações Pessoais”
              (conforme definido na Lei de Privacidade do Consumidor da
              Califórnia — “CCPA”), a Loadsmart atuará como “Controladora” ou
              “Empresa” dos Dados de Usuários Terceiros e como “Operadora” ou
              “Prestadora de Serviços” dos Dados do Cliente, respectivamente. A
              Loadsmart utiliza e compartilha Dados Pessoais e Informações
              Pessoais conforme estabelecido em sua política de privacidade. A
              Loadsmart não “Vende” Informações Pessoais, conforme tal termo é
              definido na CCPA. Caso o Cliente opte, em um Formulário de Pedido
              ou Declaração de Trabalho, por transferir Dados Pessoais da Área
              Econômica Europeia para a Loadsmart em um país terceiro, as partes
              celebrarão um Acordo de Processamento de Dados (“APD”), que será
              incorporado a este Acordo por referência. Para fins deste Acordo,
              os termos Controladora, Operadora e Dados Pessoais terão os
              significados estabelecidos no GDPR, e os termos Empresa,
              Prestadora de Serviços, Informações Pessoais e Vender terão os
              significados estabelecidos na CCPA.
            </Paragraph>
          </div>
          <div>
            <TitleH2>8. GARANTIAS E ISENÇÕES DE RESPONSABILIDADE</TitleH2>
            <Paragraph>
              <TitleH3>8.1. Declarações e Garantias da Loadsmart.</TitleH3>A
              Loadsmart declara e garante o seguinte em relação aos Serviços:
            </Paragraph>
            <BulltetList>
              <li>
                <Paragraph>
                  <TitleH4>8.1.1.</TitleH4>A Loadsmart garante que os Serviços
                  de Assinatura estarão substancialmente em conformidade com as
                  funcionalidades estabelecidas na Documentação. Se os Serviços
                  de Assinatura não estiverem substancialmente em conformidade
                  com as funcionalidades estabelecidas na Documentação, a única
                  e exclusiva obrigação da Loadsmart será envidar esforços
                  comercialmente razoáveis para corrigir a não conformidade ou,
                  a critério exclusivo da Loadsmart, se tal medida não for
                  viável, o Cliente poderá rescindir este Acordo nos termos da
                  Seção 9.2. A garantia estabelecida nesta Seção 8.1.1 não se
                  aplicará: (i) se o Cliente apresentar uma reclamação de não
                  conformidade mais de trinta (30) dias após a data em que o
                  Cliente percebeu pela primeira vez a não conformidade; (ii) se
                  a não conformidade foi causada por uso indevido, modificações
                  não autorizadas ou hardware, software ou serviços de
                  terceiros; ou (iii) se os Serviços de Assinatura estiverem
                  sendo oferecidos sem cobrança, em caráter experimental ou de
                  avaliação.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.1.2.</TitleH4> A Loadsmart declara e garante que os
                  Serviços serão de qualidade profissional, em conformidade com
                  os padrões e práticas geralmente aceitos no setor.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.1.3.</TitleH4> A Loadsmart deverá, a todo momento,
                  cumprir todas as leis, normas e regulamentos aplicáveis,
                  incluindo leis de privacidade de dados, e os termos deste
                  Acordo durante a prestação dos Serviços pela Loadsmart.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.1.4.</TitleH4>
                  Se a Loadsmart utilizar ou licenciar Propriedade Intelectual
                  de terceiros na execução ou prestação dos Serviços, a
                  Loadsmart declara e garante que obteve todas as licenças e
                  autorizações necessárias para o uso válido de tal Propriedade
                  Intelectual de terceiros em conexão com os Serviços.
                </Paragraph>
              </li>
            </BulltetList>
            <Paragraph>
              <TitleH3>8.2. Declarações e Garantias do Cliente.</TitleH3> O
              Cliente declara e garante o seguinte em relação ao uso dos
              Serviços e ao fornecimento dos Dados do Cliente:
            </Paragraph>
            <BulltetList>
              <li>
                <Paragraph>
                  <TitleH4>8.2.1.</TitleH4> O Cliente possui as licenças,
                  direitos, consentimentos e permissões necessários para
                  utilizar os Dados do Cliente e para permitir que seus Usuários
                  Autorizados e a Loadsmart usem e distribuam os Dados do
                  Cliente conforme necessário para prestar e utilizar os
                  Serviços.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.2.2.</TitleH4>
                  Os Dados do Cliente, e o uso dos mesmos conforme aqui
                  contemplado, não infringem, violam nem se apropriam
                  indevidamente de quaisquer leis aplicáveis ou de qualquer
                  direito de terceiros, incluindo direitos autorais, marcas
                  registradas, patentes, segredos comerciais, direitos morais,
                  direitos de privacidade, direitos de publicidade, direitos
                  contratuais ou qualquer outro direito de Propriedade
                  Intelectual ou direito proprietário.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.2.3.</TitleH4> O Cliente deverá, a todo momento,
                  cumprir todas as leis, normas e regulamentos aplicáveis,
                  incluindo leis de privacidade de dados, e os termos deste
                  Acordo durante o uso dos Serviços pelo Cliente.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.2.4.</TitleH4> O Cliente não deverá adotar qualquer
                  conduta que possa fazer com que um vírus ou outro código de
                  computador, arquivo ou programa interrompa, destrua ou limite
                  a funcionalidade dos Serviços de Assinatura e/ou de qualquer
                  hardware ou equipamento tecnológico relacionado, ou de outra
                  forma permita o acesso ou uso não autorizado dos Serviços de
                  Assinatura.
                </Paragraph>
              </li>
            </BulltetList>

            <Paragraph>
              <TitleH3>8.3. Uso pelo Cliente e Dados.</TitleH3> A Loadsmart não
              terá qualquer responsabilidade por quaisquer reclamações, perdas
              ou danos causados por erros ou omissões em quaisquer informações
              fornecidas pelo Cliente ou seus Usuários Autorizados à Loadsmart
              em conexão com os Serviços. Exceto conforme estabelecido de outra
              forma neste instrumento, a Loadsmart isenta expressamente qualquer
              e toda responsabilidade em conexão com os Dados do Cliente. A
              Loadsmart não tem obrigação de editar ou controlar os Dados do
              Cliente, incluindo os Dados do Cliente inseridos pelo Cliente nos
              Serviços de Assinatura. A Loadsmart poderá, a qualquer momento e
              sem aviso prévio, remover quaisquer Dados do Cliente que violem
              este Acordo ou a lei aplicável, ou que violem os direitos de
              terceiros ou da Loadsmart.
            </Paragraph>
            <Paragraph>
              <TitleH3>8.4. Isenção Geral de Responsabilidade.</TitleH3> EXCETO
              PELAS GARANTIAS PREVISTAS NESTE ACORDO, OS SERVIÇOS SÃO FORNECIDOS
              “NO ESTADO EM QUE SE ENCONTRAM” E A LOADSMART ISENTA EXPRESSAMENTE
              TODAS AS GARANTIAS DE QUALQUER NATUREZA RELATIVAS AOS SERVIÇOS
              AQUI PRESTADOS, SEJAM EXPRESSAS OU IMPLÍCITAS, INCLUINDO, MAS NÃO
              SE LIMITANDO ÀS GARANTIAS IMPLÍCITAS DE COMERCIALIZAÇÃO, TÍTULO,
              ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA E NÃO INFRAÇÃO.
            </Paragraph>
            <Paragraph>
              <TitleH3>8.5. Isenção de Responsabilidade por IA.</TitleH3>{' '}
              DETERMINADAS FUNCIONALIDADES E RECURSOS DOS SERVIÇOS DE ASSINATURA
              SÃO DESENVOLVIDOS POR INTELIGÊNCIA ARTIFICIAL DE TERCEIROS E A
              LOADSMART NÃO FAZ, E AQUI ISENTA, QUAISQUER E TODAS AS DECLARAÇÕES
              OU GARANTIAS, EXPRESSAS OU IMPLÍCITAS, INCLUINDO GARANTIAS DE
              TÍTULO, COMERCIALIZAÇÃO, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA,
              PRECISÃO, INTEGRIDADE E NÃO INFRAÇÃO DE DIREITOS DE TERCEIROS, EM
              RELAÇÃO A QUAISQUER INFORMAÇÕES, RECOMENDAÇÕES, RESPOSTAS,
              ANÁLISES OU OUTROS DADOS FORNECIDOS POR TAIS FUNCIONALIDADES OU
              RECURSOS A CADA USUÁRIO AUTORIZADO.
            </Paragraph>
          </div>
          <div>
            <TitleH2>9. VIGÊNCIA E RESCISÃO</TitleH2>
            <Paragraph>
              <TitleH3>9.1. Vigência.</TitleH3>
              Este Acordo entra em vigor na Data de Vigência e permanecerá em
              plena vigência e eficácia: (a) para cada Formulário de Pedido, até
              o término do Período de Assinatura; e (b) para cada Declaração de
              Trabalho, até o término do prazo aplicável estabelecido na mesma.
              Para os Serviços de Assinatura, o Período de Assinatura será
              automaticamente renovado por períodos subsequentes de doze (12)
              meses após a conclusão do Período de Assinatura inicial, salvo se
              qualquer das partes fornecer à outra parte aviso por escrito de
              rescisão com pelo menos trinta (30) dias de antecedência do
              vencimento do Período de Assinatura então vigente.
            </Paragraph>
            <Paragraph>
              <TitleH3>9.2. Rescisão por Inadimplemento.</TitleH3> Se qualquer
              das partes cometer inadimplemento material de suas obrigações
              neste Acordo, em qualquer Formulário de Pedido ou Declaração de
              Trabalho (incluindo obrigações de pagamento), a parte não
              inadimplente poderá notificar por escrito a parte inadimplente
              especificando a natureza do inadimplemento, e se tal
              inadimplemento não for sanado no prazo de trinta (30) dias a
              partir do recebimento de tal notificação, a parte não inadimplente
              terá o direito de rescindir imediatamente este Acordo ou o
              Formulário de Pedido ou Declaração de Trabalho mediante
              notificação por escrito. Se o inadimplemento se relacionar
              exclusivamente a um Formulário de Pedido ou Declaração de
              Trabalho, somente tal Formulário de Pedido ou Declaração de
              Trabalho poderá ser rescindido nos termos aqui previstos, e todos
              os demais Formulários de Pedido e Declarações de Trabalho, bem
              como este Acordo, permanecerão em plena vigência e eficácia. No
              caso de rescisão de um Formulário de Pedido pelo Cliente nos
              termos desta Seção 9.2, o Cliente terá direito ao reembolso
              proporcional de quaisquer honorários pré-pagos relativos ao
              restante do Período de Assinatura a contar da data efetiva de
              rescisão.
            </Paragraph>
            <Paragraph>
              <TitleH3>9.3. Rescisão por Insolvência.</TitleH3>
              Não obstante qualquer disposição contrária neste instrumento,
              qualquer das partes poderá rescindir este Acordo imediatamente
              mediante notificação por escrito à outra parte no caso de a outra
              parte tornar-se insolvente, realizar cessão de bens em benefício
              de credores, encerrar suas atividades, ou caso qualquer processo
              de falência, reorganização, acordo, insolvência, liquidação ou
              outro processo previsto em qualquer lei de falência ou de amparo a
              devedores seja instaurado por ou contra tal parte e não seja
              extinto no prazo de sessenta (60) dias subsequentes.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                9.4. Direitos e Obrigações por Ocasião do Vencimento ou
                Rescisão.
              </TitleH3>
              Por ocasião do vencimento ou rescisão deste Acordo, (i) o direito
              do Cliente e de seus Usuários Autorizados de acessar e utilizar os
              Serviços de Assinatura será imediatamente encerrado; (ii) o
              Cliente e seus Usuários Autorizados deverão imediatamente cessar
              todo uso dos Serviços de Assinatura; (iii) o Cliente deverá
              excluir ou devolver, e não mais utilizar, quaisquer materiais,
              Informações Confidenciais da Loadsmart, Documentação, Propriedade
              Intelectual da Loadsmart, nomes de usuário, senhas ou outros itens
              (e todas as cópias dos mesmos) obtidos em conexão com os Serviços;
              e (iv) o Cliente não terá mais acesso a quaisquer Dados do Cliente
              inseridos nos Serviços de Assinatura.
            </Paragraph>
            <Paragraph>
              <TitleH3>9.5. Sobrevivência.</TitleH3>Por ocasião da rescisão,
              qualquer disposição que, por sua natureza ou termos expressos,
              deva sobreviver, sobreviverá, incluindo, mas não se limitando às
              Seções 5, 6, 7, 10, 11 e 12.
            </Paragraph>
          </div>
          <div>
            <TitleH2>10. INDENIZAÇÃO</TitleH2>
            <Paragraph>
              <TitleH3>10.1. Indenização pelo Cliente.</TitleH3>O Cliente deverá
              indenizar, defender e isentar de responsabilidade a Loadsmart,
              suas Afiliadas e subsidiárias, e seus respectivos diretores,
              conselheiros e funcionários, de e contra quaisquer
              responsabilidades, perdas, danos e despesas, incluindo custas
              judiciais e honorários advocatícios razoáveis, associados a
              qualquer reclamação de terceiros na proporção e medida decorrente
              de: (i) uso dos Serviços pelo Cliente ou seus Usuários
              Autorizados, ou por qualquer pessoa a quem o Cliente tenha
              concedido acesso para utilizar os Serviços, de forma que viole as
              leis aplicáveis, os termos deste Acordo ou os termos do APD (se
              aplicável); (ii) alegação de que quaisquer Dados do Cliente violam
              direitos de privacidade, direitos de Propriedade Intelectual ou
              outros direitos de terceiros; ou (iii) inadimplemento material
              deste Acordo pelo Cliente. As obrigações do Cliente nos termos
              desta Seção 10.1 estão condicionadas ao fornecimento à Loadsmart
              de pronta notificação por escrito de tal reclamação pelo Cliente.
            </Paragraph>
            <Paragraph>
              <TitleH3>10.2. Indenização pela Loadsmart.</TitleH3> A Loadsmart
              deverá indenizar, defender e isentar de responsabilidade o
              Cliente, seus diretores, conselheiros e funcionários, de e contra
              quaisquer responsabilidades, perdas, danos e despesas, incluindo
              custas judiciais e honorários advocatícios razoáveis, associados a
              qualquer reclamação de terceiros na proporção e medida decorrente
              de: (i) infração ou apropriação indevida de quaisquer direitos de
              Propriedade Intelectual de terceiros pelo uso autorizado pelo
              Cliente de um Entregável ou dos Serviços de Assinatura; (ii)
              violação de lei aplicável pela Loadsmart; ou (iii) inadimplemento
              material deste Acordo pela Loadsmart. As obrigações da Loadsmart
              nos termos desta Seção 10.2 estão condicionadas a: (a) o Cliente
              fornecer à Loadsmart pronta notificação por escrito de tal
              reclamação; (b) o Cliente fornecer cooperação razoável à
              Loadsmart, às expensas da Loadsmart, na defesa e resolução de tal
              reclamação; (c) a Loadsmart ter autoridade exclusiva para defender
              ou resolver tal reclamação. Com relação às reclamações descritas
              no item (i) acima, no caso de a capacidade da Loadsmart de prestar
              os Serviços de Assinatura ou o uso de um Entregável pelo Cliente
              ser objeto de medida inibitória, ou se, na opinião razoável da
              Loadsmart, tal medida for provável, a Loadsmart poderá obter o
              direito de continuar prestando os Serviços de Assinatura ou de
              permitir o uso do Entregável aplicável pelo Cliente, substituir ou
              modificar os Serviços de Assinatura ou o Entregável aplicável de
              forma que se tornem não infratores, ou, se tais medidas não forem
              comercialmente viáveis, rescindir este Acordo sem responsabilidade
              para com o Cliente e fornecer o reembolso proporcional de
              quaisquer honorários pré-pagos e não utilizados por ocasião de tal
              rescisão. O acima exposto constitui a totalidade das obrigações da
              Loadsmart em relação a qualquer alegada ou real infração ou
              apropriação indevida de direitos de Propriedade Intelectual pelos
              Serviços de Assinatura ou por um Entregável. A Loadsmart não terá
              qualquer responsabilidade ou obrigação nos termos desta Seção 10.2
              por quaisquer reclamações de infração causadas, no todo ou em
              parte, por: (x) qualquer instrução, informação, design ou outros
              materiais fornecidos pelo Cliente à Loadsmart como parte dos
              Serviços; (y) modificação dos Serviços de Assinatura ou de um
              Entregável por qualquer parte que não a Loadsmart, sem o
              consentimento expresso por escrito da Loadsmart; ou (z) a
              combinação, operação ou uso dos Serviços de Assinatura ou de um
              Entregável com outro(s) produto(s), dados ou serviços nos quais os
              Serviços de Assinatura ou o Entregável aplicável não seriam, por
              si só, infratores. Não obstante qualquer disposição contrária
              neste instrumento, a Loadsmart não terá qualquer obrigação ou
              responsabilidade nos termos desta Seção 10.2 por quaisquer
              reclamações decorrentes de negligência, conduta dolosa ou fraude
              do Cliente.
            </Paragraph>
          </div>
          <div>
            <TitleH2>11. LIMITAÇÃO DE RESPONSABILIDADE</TitleH2>
            <Paragraph>
              <TitleH3>11.1. Renúncia de Danos.</TitleH3>
              EXCETO NA HIPÓTESE DE UMA REIVINDICAÇÃO EXCLUÍDA, EM NENHUMA
              HIPÓTESE QUALQUER DAS PARTES SERÁ RESPONSÁVEL PERANTE A OUTRA
              PARTE POR QUAISQUER DANOS INDIRETOS, INCIDENTAIS, ESPECIAIS,
              EXEMPLARES, DE CONFIANÇA, PUNITIVOS OU CONSEQUENTES, INCLUINDO
              PERDA DE RENDA, DADOS, LUCROS, RECEITA OU INTERRUPÇÃO DE NEGÓCIOS,
              OU CUSTO DE SERVIÇOS SUBSTITUTOS, OU OUTRA PERDA ECONÔMICA,
              INDEPENDENTEMENTE DE TAL PARTE TER SIDO INFORMADA DA POSSIBILIDADE
              DE TAIS DANOS, E INDEPENDENTEMENTE DE QUALQUER PEDIDO DE
              RECUPERAÇÃO ESTAR BASEADO EM TEORIAS DE CONTRATO, GARANTIA, ATO
              ILÍCITO (INCLUINDO NEGLIGÊNCIA E RESPONSABILIDADE OBJETIVA) OU DE
              OUTRA FORMA, E CADA PARTE AQUI RENUNCIA E DISPENSA QUAISQUER
              RECLAMAÇÕES CONTRA A OUTRA PARTE RELATIVAS A TAL RESPONSABILIDADE
              E DANOS.
            </Paragraph>
            <Paragraph>
              <TitleH3>11.2. Limite de Responsabilidade.</TitleH3>
              Na máxima extensão permitida por lei, em nenhuma hipótese a
              responsabilidade agregada da Loadsmart perante o Cliente em
              conexão com este Acordo, por todas e quaisquer reclamações,
              perdas, custos ou danos de qualquer natureza, incluindo honorários
              advocatícios razoáveis, excederá o total dos honorários pagos pelo
              Cliente nos termos do Formulário de Pedido ou Declaração de
              Trabalho aplicável no período de doze (12) meses anterior ao
              incidente que deu origem à reclamação ou ação aplicável,
              independentemente da forma ou teoria da reclamação ou ação.
            </Paragraph>
          </div>
          <div>
            <TitleH2>12. DISPOSIÇÕES GERAIS</TitleH2>
            <Paragraph>
              <TitleH3>12.1. Lei Aplicável; Foro.</TitleH3>
              Este Acordo e todas as matérias decorrentes ou relacionadas a este
              Acordo serão regidos pelas leis do Estado de Illinois, sem
              consideração às disposições sobre conflitos de leis. A jurisdição
              exclusiva para qualquer reclamação ou controvérsia decorrente ou
              relacionada a este Acordo será dos tribunais estaduais e federais
              localizados no Condado de Cook, Illinois, e cada parte aqui
              renúncia irrevogável e incondicionalmente à defesa de foro
              inconveniente.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.2. Aditamento; Renúncia.</TitleH3>
              Exceto conforme de outra forma previsto neste instrumento, este
              Acordo somente poderá ser alterado por instrumento escrito
              celebrado por representante devidamente autorizado de cada parte.
              Nenhuma renúncia a qualquer disposição deste instrumento será
              eficaz, salvo se feita por escrito e assinada pela parte
              renunciante. O descumprimento de qualquer parte em exigir o
              cumprimento de qualquer termo ou obrigação deste Acordo, ou a
              renúncia por qualquer parte a qualquer inadimplemento deste
              Acordo, não impedirá a execução subsequente de tal termo ou
              obrigação, nem será considerado renúncia a qualquer inadimplemento
              subsequente.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.3. Modificações.</TitleH3>
              Não obstante qualquer disposição contrária na Seção 12.2,
              periodicamente, a Loadsmart poderá modificar este Acordo em
              relação aos Serviços de Assinatura e, salvo indicação contrária da
              Loadsmart, as modificações entrarão em vigor na data mais antiga
              entre: (i) o acesso ou uso dos Serviços de Assinatura pelo Cliente
              após quaisquer modificações; (ii) a aceitação pelo Cliente dos
              termos modificados via clique de confirmação (click-through); ou
              (iii) via e-mail para o endereço designado no Formulário de Pedido
              aplicável. Para Formulários de Pedido em vigor antes de quaisquer
              modificações, o Cliente poderá rescindir o Formulário de Pedido
              aplicável no prazo de trinta (30) dias a partir da data em que as
              modificações entrarem em vigor e receberá, como único recurso, o
              reembolso de quaisquer honorários pré-pagos pelo restante do
              Período de Assinatura.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.4. Subcontratação.</TitleH3>
              Nada neste Acordo impedirá a Loadsmart de utilizar os serviços de
              qualquer subcontratado que considere adequado para cumprir suas
              obrigações nos termos deste Acordo; desde que, no entanto, a
              Loadsmart exija que seus subcontratados cumpram todos os termos e
              condições aplicáveis deste Acordo na prestação de tais serviços, e
              a Loadsmart permaneça primariamente responsável perante o Cliente
              pelo desempenho de tal subcontratado.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.5. Notificações.</TitleH3>
              Quaisquer notificações fornecidas pela Loadsmart nos termos deste
              Acordo serão enviadas para o endereço estabelecido no Formulário
              de Pedido ou Declaração de Trabalho aplicável. As notificações e
              todas as demais comunicações aqui previstas serão consideradas
              recebidas: (i) quando efetivamente recebidas, se entregues
              pessoalmente ou por courier; ou (ii) cinco (5) dias após o envio,
              se remetidas por correspondência registrada, com porte pago e
              aviso de recebimento. As notificações fornecidas à Loadsmart
              deverão incluir uma cópia por e-mail para{' '}
              <Link href="mailto:legal@loadsmart.com">Legal@Loadsmart.com</Link>
              .
            </Paragraph>
            <Paragraph>
              <TitleH3>12.6. Divisibilidade.</TitleH3>
              Se qualquer disposição deste Acordo for declarada inválida ou
              inexequível, as demais disposições permanecerão em plena vigência
              e eficácia.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.7. Força Maior.</TitleH3>
              Nenhuma das partes será responsável nos termos deste instrumento
              por qualquer falha ou atraso no cumprimento de suas obrigações
              aqui previstas (exceto pelo pagamento de honorários) em
              decorrência de eventos além do controle razoável de tal parte, que
              podem incluir, sem limitação, ataques de negação de serviço,
              ataques cibernéticos, greves (exceto por seus próprios
              funcionários), escassez, distúrbios, insurreição, incêndios,
              inundações, pandemias, epidemias, tempestades, explosões, atos de
              Deus, guerra, terrorismo, ação governamental, condições
              trabalhistas, terremotos, falha ou redução de energia, redes de
              telecomunicações ou de dados, e escassez de materiais (cada um, um
              “Evento de Força Maior”). Após a ocorrência de um Evento de Força
              Maior, a parte inadimplente ficará isenta de qualquer execução
              adicional de suas obrigações afetadas pelo Evento de Força Maior
              enquanto o Evento de Força Maior perdurar, desde que tal parte
              empregue esforços comercialmente razoáveis para retomar o
              cumprimento.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.8. Conformidade com as Leis.</TitleH3>
              Cada parte concorda em cumprir todas as leis aplicáveis, incluindo
              as leis de exportação dos EUA, e os regulamentos com relação às
              suas atividades nos termos deste instrumento.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.9. Relação entre as Partes.</TitleH3>
              Nada neste Acordo deverá ser interpretado como criando uma
              parceria, joint venture ou relação de agência entre as partes.
              Nenhuma das partes terá o poder de vincular a outra ou de assumir
              obrigações em nome da outra sem o consentimento prévio por escrito
              desta.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.10. Cessão/Sucessores.</TitleH3>
              Nenhuma das partes poderá ceder ou transferir um Formulário de
              Pedido, uma Declaração de Trabalho ou este Acordo, no todo ou em
              parte, sem o consentimento prévio por escrito da outra parte. Não
              obstante o acima exposto, a Loadsmart poderá livremente ceder ou
              transferir este Acordo a qualquer uma de suas Afiliadas ou a
              qualquer adquirente de todos ou substancialmente todos os seus
              ativos, ou em conexão com qualquer fusão ou incorporação. Qualquer
              tentativa de cessão ou transferência em violação desta Seção será
              nula e sem efeito.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.11. Acordo Integral.</TitleH3>
              Este Acordo, juntamente com o Formulário de Pedido ou Declaração
              de Trabalho aplicável, constitui o acordo completo e exclusivo
              entre as partes acerca de seu objeto e substitui todos os acordos
              ou entendimentos anteriores ou contemporâneos, escritos ou
              verbais, relativos ao objeto deste Acordo. Este Acordo poderá ser
              celebrado em contrapartes, cada uma das quais será considerada um
              original e todas em conjunto serão consideradas um único e mesmo
              acordo. Nenhuma disposição de qualquer ordem de compra ou outro
              formulário comercial semelhante utilizado pelo Cliente prevalecerá
              sobre os termos e condições deste Acordo, e qualquer documento
              relacionado a este Acordo será apenas para fins administrativos e
              não terá efeito jurídico com relação aos Serviços.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.12. Tutela de Urgência.</TitleH3>
              Cada parte reconhece que o descumprimento pela outra parte de
              qualquer dos direitos de confidencialidade estabelecidos na Seção
              7.1 ou dos direitos de Propriedade Intelectual estabelecidos na
              Seção 6 deste Acordo pode causar à parte não inadimplente danos
              irreparáveis, para os quais a condenação em perdas e danos não
              seria compensação adequada. Consequentemente, a parte não
              inadimplente poderá requerer medida inibitória para coibir
              qualquer violação ou ameaça de violação dessas disposições, além
              de qualquer outro recurso ao qual a parte não inadimplente possa
              ter direito em lei ou em equidade.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.13. Ausência de Terceiros Beneficiários.</TitleH3>
              Este Acordo destina-se exclusivamente ao benefício dos signatários
              e não pretende beneficiar terceiros. Apenas as partes neste
              instrumento poderão fazer cumprir este Acordo.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.14. Ordem de Precedência.</TitleH3>
              Em caso de conflito entre os termos de um Formulário de Pedido ou
              Declaração de Trabalho e este Acordo, o Formulário de Pedido ou a
              Declaração de Trabalho, conforme aplicável, prevalecerá.
            </Paragraph>
          </div>
        </Layout>
      </>
      <Footer />
    </>
  );
};

export default SubscriptionAndProfessionalServicesAgreementPT;
export { SubscriptionAndProfessionalServicesAgreementPT };
